export default __webpack_public_path__ + "static/media/Ajesh.9b59a230.jpg";